<template>
  <div>
    <select
      v-model="selectedOption"
      @change="onSearch"
      class="justify-content-end align-self-center pb-1 customgrid-search-bar"
    >
      <option value="">{{ $t("selectOption") }}</option>
      <option value="bookable">{{ $t("open") }}</option>
      <option value="closed">{{ $t("closed") }}</option>
    </select>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  data() {
    return {
      selectedOption: "",
      columnList: ["Select Type", "Open", "Close"],
    };
  },
  created() {
    eventBus.$on("clear-filters", this.clearFilters);
  },
  props: {
    columnHeader: String,
    onCustomEvent: Function,
  },
  mounted() {
    if (sessionStorage.getItem("status")) {
      this.selectedOption = sessionStorage.getItem("status");
    }

    if (sessionStorage.getItem("statusInactive")) {
      this.selectedOption = sessionStorage.getItem("statusInactive");
    }
  },
  methods: {
    clearFilters() {
      const columnHeader = this.params.columnHeader;

      if (columnHeader == "status") {
        sessionStorage.removeItem("status");
      }

      if (columnHeader == "statusInactive") {
        sessionStorage.removeItem("statusInactive");
      }
      this.selectedOption = "";
    },
    onSearch() {
      const searchText = this.selectedOption;
      const columnHeader = this.params.columnHeader;
      if (columnHeader === "status") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("status", searchText);
        } else {
          sessionStorage.removeItem("status");
        }
      }

      if (columnHeader === "statusInactive") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("statusInactive", searchText);
        } else {
          sessionStorage.removeItem("statusInactive");
        }
      }

      this.$parent.$listeners.onFilterChanged(columnHeader, searchText);
    },
  },
};
</script>
